import { render, staticRenderFns } from "./ModelsContainer.vue?vue&type=template&id=42abc952&scoped=true&"
import script from "./ModelsContainer.vue?vue&type=script&lang=js&"
export * from "./ModelsContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModelsContainer.vue?vue&type=style&index=0&id=42abc952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42abc952",
  null
  
)

component.options.__file = "ModelsContainer.vue"
export default component.exports